module.exports = __webpack_public_path__ + "img/features01-02.9e04900.jpg";